
import { Component, Prop, Vue } from "vue-property-decorator";
import { API_TCompany, API_TCompany_Filter } from "@/models/cases_expert_companies";
import { SUCCESS_NOTIFICATION_TYPE, ERROR_NOTIFICATION_TYPE } from "@/constants/notification";
import {
  COMPLIANT_LABEL,
  EMPLOYEE_EMPLOYMENT_STATUS_MARKING,
  EXPERT_ARCHIVED_EMPLOYEE_TAB,
  NOT_COMPLIANT_LABEL,
} from "@/constants/compliance";
import { SMUser } from "@/store";
import { API_TExpert_Employee } from "@/models/cases_expert_employee";

type ParamsKeyObject = {
  [key: string]: any;
};

const SMALL_FONT_SIZE = "small";

@Component
export default class ExpertCompaniesTable extends Vue {
  @Prop({ type: Array, default: () => ({}) }) readonly items?: API_TCompany[];
  @Prop({ type: Object, default: () => ({}) }) readonly params?: ParamsKeyObject;
  @Prop({ type: Object, default: () => ({}) }) readonly filters?: API_TCompany_Filter;
  @Prop({ type: Boolean, default: false }) readonly loading?: boolean;
  @Prop({ type: String }) readonly tabName?: string;

  get tableProps() {
    const { tabName, loading, headers, headersPremium, items, filters, labels, params } = this;

    return {
      loading,
      headers: tabName === EXPERT_ARCHIVED_EMPLOYEE_TAB ? headersPremium : headers,
      items,
      filters,
      labels,
      params,
      fontSize: SMALL_FONT_SIZE,
    };
  }

  options = {
    infiniteScroll: true,
    filtersApi: true,
    sortApi: true,
  };

  labels = {
    allLabel: this.$t("table.allLabel"),
    placeholderLabel: this.$t("table.placeholderLabel"),
  };

  headers = [
    {
      text: this.$t("table.headers.name"),
      value: "name",
      slot: true,
    },
    {
      text: this.$t("table.headers.workEmail"),
      value: "work_email",
    },
    {
      text: this.$t("table.headers.companyName"),
      value: "company_name",
      filterable: true,
      width: "70",
    },
    {
      text: this.$t("table.headers.complianceStatus"),
      value: "compliance_status",
      filterable: true,
      error: NOT_COMPLIANT_LABEL,
      success: COMPLIANT_LABEL,
      width: "45",
    },
    {
      text: this.$t("table.headers.complianceSubscription"),
      value: "compliance_subscription",
      width: "55",
      filterable: true,
    },
    {
      text: this.$t("table.headers.visaExpiration"),
      value: "visa_expiration",
      sortable: true,
      sortBy: "date",
      width: "110",
    },
    {
      text: this.$t("table.headers.pendingTasks"),
      value: "pending_tasks",
      filterable: true,
      multipleSelect: false,
      width: "20",
    },
  ];

  headersPremium = [
    {
      text: this.$t("table.headers.name"),
      value: "name",
      slot: true,
    },
    {
      text: this.$t("table.headers.workEmail"),
      value: "work_email",
    },
    {
      text: this.$t("table.headers.companyName"),
      value: "company_name",
      filterable: true,
      width: "70",
    },
    {
      text: this.$t("table.headers.complianceStatus"),
      value: "compliance_status",
      filterable: true,
      error: NOT_COMPLIANT_LABEL,
      success: COMPLIANT_LABEL,
      width: "45",
    },
    {
      text: this.$t("table.headers.visaExpiration"),
      value: "visa_expiration",
      sortable: true,
      sortBy: "date",
      width: "110",
    },
    {
      text: this.$t("table.headers.pendingTasks"),
      value: "pending_tasks",
      filterable: true,
      multipleSelect: false,
      width: "20",
    },
    {
      text: this.$t("table.headers.tasksToReport"),
      value: "tasks_to_report",
      sortable: true,
    },
  ];

  tableActive = true;

  loadData(payload: any) {
    this.$emit("load-data", payload);
  }

  navigateEmployee(item: API_TExpert_Employee) {
    if (!item.id) return;

    const { id, company_id } = item;

    const path = `${SMUser.basePath}/companies/${company_id}/employees/${id}`;

    const routeData = this.$router.resolve(path);

    window.open(routeData.href, "_blank");
  }

  copyToClipboard(text: string) {
    if (!navigator.clipboard) return;

    let type: string;
    let title: string;

    try {
      navigator.clipboard.writeText(text);

      type = SUCCESS_NOTIFICATION_TYPE;
      title = `"${text}" ${this.$t("copied")}`;
    } catch (err) {
      type = ERROR_NOTIFICATION_TYPE;
      title = err as string;
    }

    this.$root.$emit("show-notification", {
      type,
      title,
    });
  }

  getClass(workingStatus: string) {
    return EMPLOYEE_EMPLOYMENT_STATUS_MARKING[workingStatus] || "";
  }
}
